export const endYearActionTypes = {
  FETCH_END_YEAR_START: 'FETCH_END_YEAR_START',
  FETCH_END_YEAR_SUCCESS: 'FETCH_END_YEAR_SUCCESS',
  FETCH_END_YEAR_FAILED: 'FETCH_END_YEAR_FAILED',
  POST_END_YEAR_START: 'POST_END_YEAR_START',
  POST_END_YEAR_SUCCESS: 'POST_END_YEAR_SUCCESS',
  POST_END_YEAR_FAILED: 'POST_END_YEAR_FAILED',
  UPDATE_END_YEAR_START: 'UPDATE_END_YEAR_START',
  UPDATE_END_YEAR_SUCCESS: 'UPDATE_END_YEAR_SUCCESS',
  UPDATE_END_YEAR_FAILED: 'UPDATE_END_YEAR_FAILED',
  DELETE_END_YEAR_START: 'DELETE_END_YEAR_START',
  DELETE_END_YEAR_SUCCESS: 'DELETE_END_YEAR_SUCCESS',
  DELETE_END_YEAR_FAILED: 'DELETE_END_YEAR_FAILED',
  HIDE_ALERT: 'HIDE_ALERT_END_YEAR',
};
